import { CoeWorkMagerEntityModel } from "src/store/models/entity/coeWorkManger/entity";
import { CoeWorkMagerHelperModel } from "src/store/models/entity/coeWorkManger/helper";

export const encooCoeWorkMagerkModels = {
  entity: CoeWorkMagerEntityModel,
  helper: CoeWorkMagerHelperModel,
};
